import {authorize, IWithRouterProps, Overlay, withRouter} from "@athena-portal/components";
import * as React from "react";
import FalconFooter from "../../../../components/navigation/FalconFooter";
import FalconHeader from "../../../../components/navigation/FalconHeader";
import {ImgTileLink} from "../../../../components/ImgTileLink";
import {Link, Navigate} from "react-router-dom";
import {SuccessfulPurchaseModal} from "../../../../components/modals/SuccessfulPurchaseModal";
import {
    ANNUAL_HOME_RENEWAL_PROPOSAL_EDIT_VIEW_JOURNEY_URL,
    AnnualPolicyPremiumTypeEnum,
    CLAIM_TYPE_OTHER,
    CommonHelpers,
    FalconNavigatorHeader,
    IFalconConvenienceApiService,
    INTERACTION_PROCESS_CHANGE_ADDRESS,
    INTERACTION_PROCESS_CLAIM_IMPACT,
    INTERACTION_PROCESS_MTA,
    INTERACTION_PROCESS_NB,
    INTERACTION_PROCESS_RENEWAL,
    PaymentDetails,
    PaymentsResponse,
    Policy,
    POLICY_STATUS_MTC,
    POLICY_STATUS_PENDING_RENEWAL,
    POLICY_STATUS_UNDERWRITING_FAILURE,
    PolicyHistory,
    PolicyProperty,
    PolicyPropertyEnum,
    productHelper,
    ProductsEnum,
    Renewal,
    resourcesHelper,
    Types
} from "@falcon/services";
import {lazyInject} from "@athena-portal/core";
import {finalize} from "rxjs/operators";
import {NextYearAutoRenewalBanner} from "../../../../components/banners/NextYearAutoRenewalBanner";
import {RenewNextYearConfirmationModal} from "../../../../components/modals/RenewNextYearConfirmationModal";
import {BackButton} from "../../../../components/navigation/BackButton";
import {AnnualProductPaymentMessageBanner} from "../../../../components/banners/AnnualProductPaymentMessageBanner";
import * as moment from "moment/moment";
import {
    ChangeAddressStorageSuccessModal
} from "../../../../components/modals/annual/home/ChangeAddressStorageSuccessModal";
import {MtaStorageSuccessModal} from "../../../../components/modals/annual/home/MtaStorageSuccessModal";
import {NoActivePolicyBanner} from "../../../../components/banners/NoActivePolicyBanner";
import {OverdueInstalmentBanner} from "../../../../components/banners/OverdueInstalmentBanner";
import {OutstandingPaymentBanner} from "../../../../components/banners/OutstandingPaymentBanner";
import {
    formatDateTime,
    getSavedValidQuotesCount,
    isAllianzAdvantagesToggleEnabled,
    setSessionStorage,
} from "../../../../CommonFunctions";
import {SportsVoucherBanner} from "../../../../components/banners/SportsVoucherBanner";
import {LVDataLayerHelper} from "../../../../utils/LVDataLayerHelper";
import {DashcamBanner} from "../../../../components/banners/DashcamBanner";
import {AutoRenewalInviteBanner} from "../../../../components/banners/AutoRenewalInviteBanner";
import {PolicyWillBeRenewedBanner} from "../../../../components/banners/PolicyWillBeRenewedBanner";
import {AnnualHomeManualRenewalModal} from "../../../../components/modals/AnnualHomeManualRenewalModal";
import {AnnualHomeManualRenewalConfirmation} from "../../../../components/modals/AnnualHomeManualRenewalConfirmation";
import {RenewalDeclinedBanner} from "../../../../components/banners/RenewalDeclinedBanner";
import {StorageSuccessModal} from "../../../../components/modals/StorageSuccessModal";
import {
    GracePeriodRenewalStorageSuccessModal
} from "../../../../components/modals/annual/home/GracePeriodRenewalStorageSuccessModal";
import {SportsPassBanner} from "../../../../components/banners/SportsPassBanner";
import {NCDImpactedClaimBanner} from "../../../../components/banners/NCDImpactedClaimBanner";
import {
    pushToAdobeDataLayerDelayed,
    putCustomerDetailsIntoAdobeDataLayer
} from "../../../../utils/AdobeDataLayerHelper";
import {GracePeriodBanner} from "../../../../components/banners/GracePeriodBanner";
import {UnpaidChangeBanner} from "../../../../components/banners/UnpaidChangeBanner";
import {DashboardCarousel} from "../../../../components/banners/carouselBanners/DashboardCarousel";
import {NewQuoteModalPopUp} from "../../../../components/modals/NewQuoteModalPopUp";
import {AllianzOnlineBadge} from "../../../../components/AllianzOnlineBadge";
import {ClaimImpactMtaSuccessModalWordingGenerator} from "../../common/ClaimImpactMtaSuccessModalWordingGenerator";
import {MtaSuccessModalWording} from "../../common/modal/MtaSuccessModalWording";
import {AutoRenewalQuestionModal} from "../../../../components/modals/AutoRenewalQuestionModal";
import {AutomaticRenewalSuccessModal} from "src/components/modals/AutomaticRenewalSuccessModal";
import {LvToAllianzUKTransferBanner} from "../../../../components/banners/LvToAllianzUKTransferBanner";
import {RefundPaymentDetailsUpdateBanner} from "../../../../components/banners/RefundPaymentDetailsUpdateBanner";
import {LackOfFoundsDelinquencyBanner} from "../../../../components/banners/LackOfFoundsDelinquencyBanner";
import {DashboardPagePlain, IBaseDashboardState, IDashboardParams} from "../../common/dashboard/DashboardPagePlain";

const { FAQ_HOME_URL, CONTACT_US_URL } = resourcesHelper;

interface ISettings {
    allianzDirectClaimsEnabled?: string | boolean;
}
const buildDigitalClaimsUrl = (baseUrl: string | undefined, policyNumber: string): string | undefined => {
    if (!baseUrl) {
        return undefined;
    }

    const separator = baseUrl.includes("?") ? "&" : "?";

    return `${baseUrl}${separator}journey=digital&policy=${encodeURIComponent(policyNumber)}`;
};

interface IHomeDashboardState extends IBaseDashboardState {
    showManualRenewalConfirmation: boolean;
    manualRenewalPopUpIsShown: boolean;
    showEditRenewalSuccessPopup: boolean;
    bannerShownLocally: boolean;
    bannerShownInSession:boolean;
    hasOldMotorPolicies?: boolean;
    paymentsHistory?: PaymentsResponse;
    allianzDirectClaimsEnabled: boolean,
}

@authorize
export class AnnualHomeDashboardPagePlain extends DashboardPagePlain<IHomeDashboardState> {

    @lazyInject(Types.FalconConvenienceApiService)
    private readonly falconConvenienceApiService: IFalconConvenienceApiService;

    constructor(props: IWithRouterProps<IDashboardParams>) {
        super(props);

        this.state = {
            ...this.state,
            showRenewalSwitchConfirmation: false,
            showManualRenewalConfirmation: false,
            manualRenewalPopUpIsShown: window.sessionStorage.getItem("manualRenewalPopUpIsShown") === "true",
            showEditRenewalSuccessPopup: window.sessionStorage.getItem("showRenewalEditSuccessPopup") === "true",
            bannerShownLocally: window.localStorage.getItem("bannerCalledLocally" + this.props.params.policyNumber) === "true",
            bannerShownInSession: window.sessionStorage.getItem("bannerCalledInSession" + this.props.params.policyNumber) === "true",
            allianzDirectClaimsEnabled: false,
        }

        this.turnOnManualNextYearRenewal = this.turnOnManualNextYearRenewal.bind(this);
        this.hideManualRenewalConfirmation = this.hideManualRenewalConfirmation.bind(this);
        this.renewalEditSuccessModalOnClose = this.renewalEditSuccessModalOnClose.bind(this);
        this.setShowManualRenewalConfirmation = this.setShowManualRenewalConfirmation.bind(this)
    }

    public componentDidMount(): void {
        this.cacheManager.clearCache("getPolicies");
        this.displayReviewDialog();
        this.loadAllianzDirectClaimsSwitch();
        this.setRedirections();
        const policyNumber: string = this.props.params.policyNumber;

        this.customerPortalService.getUserPoliciesWithLatestVersions().subscribe((policies: Policy[]) => {
            this.customerPortalService.getExpiredPolicies()
                .subscribe(expiredPolicies => {
                        this.setState({
                            hasExpiredPolicies: Boolean(expiredPolicies && expiredPolicies.length > 0),
                            hasOldMotorPolicies: this.filterByProduct(expiredPolicies, ProductsEnum.WOLF_MOTOR).length > 0
                        });
                    });

            const homePolicies:  Policy[] = [...policies]
                .filter((policy: Policy) => policy.products.includes(this.product))
                .sort((a, b) => moment(b.endDate).diff(a.endDate));
            const filteredPolicy: Policy = homePolicies
                .filter((policy: Policy) => policy.policyNumber === this.props.params.policyNumber)[0];

            if (homePolicies.length === 0) {
                this.setState({
                    policiesProcessed: true
                });
                return;
            }
            this.mountForPolicy(filteredPolicy);

            if (filteredPolicy) {
                this.loadPaymentsHistoryWhenInRenewalWindow(filteredPolicy, policyNumber);
                if (filteredPolicy?.policyHolder) {
                    putCustomerDetailsIntoAdobeDataLayer({
                        emailAddress: filteredPolicy.policyHolder.email,
                        mobileNumber: filteredPolicy.policyHolder.phoneMobile,
                        postcode: filteredPolicy.policyHolder.address?.postalCode
                    });
                }
               this.loadHasFailedCardRefundAndApplicableForDDValue(policyNumber);
            }
        });
        this.fetchQuotes();

        window.sessionStorage.setItem("fromDashboard", "true");
        this.pushToAdobeDataLayerTimeout = pushToAdobeDataLayerDelayed(2000);
    }

    componentWillUnmount() {
        clearTimeout(this.pushToAdobeDataLayerTimeout);
    }

    private readonly mountForPolicy = (policy: Policy) => {
        policy.interaction?.agreementVersionId ?
            this.fetchInstalmentInfos(policy) :
            this.setState({instalmentInfoLoaded: true});

        this.setState({policy});
        this.loadPartyAndMarketingPreferences();

        this.customerPortalService.getRenewalProposal(policy.policyNumber).subscribe(
            (renewalProposal: Renewal) => {
                this.setState({
                    renewalProposal
                });
            }
        );

        this.loadPolicyHistoryAfterRenewal();

        this.customerPortalService
            .getPolicyPropertiesByPropertyKeys(this.props.params.policyNumber, [PolicyPropertyEnum.PERFORM_RENEWAL, PolicyPropertyEnum.REUSE_MAIN_CARD])
            .pipe(finalize(() => this.setState({policyPropertiesLoaded: true})))
            .subscribe((properties: PolicyProperty[]) => {
                    properties.forEach(property => {
                        if (property.key === PolicyPropertyEnum.AUTOMATIC_RENEWAL) {
                            this.setState({automaticRenewal: property.value === 'true'});
                        } else if (property.key === PolicyPropertyEnum.PERFORM_RENEWAL) {
                            this.setState({performRenewal: property.value === "true"})
                        } else if (property.key === PolicyPropertyEnum.REUSE_MAIN_CARD) {
                            this.setState({reuseCard: property.value === 'true'})
                        }
                    })
                }
            );

    }

    public render(): React.ReactNode {
        const policy: Policy = this.state.policy!;
        this.referrerJourney = window.sessionStorage.getItem("referrerJourney");
        this.showSuccessPopup = window.sessionStorage.getItem("showPopup");
        const policyHolder: any = policy?.policyHolder;
        const interaction: any = policy?.interaction;
        const monthly: boolean = interaction?.factors?.premiumType === AnnualPolicyPremiumTypeEnum.MONTHLY;
        const futureCancelledPolicyBeforeInception: boolean = policy != null && moment.utc(policy.endDate, moment.ISO_8601).isSame(moment.utc(policy.startDate, moment.ISO_8601))
            && moment.utc(policy.startDate, moment.ISO_8601).isAfter(moment(), 'day');
        const hasPendingRenewal: boolean = this.state.renewalProposal != null && this.state.renewalProposal.status === POLICY_STATUS_PENDING_RENEWAL;

        if (policyHolder && this.state.policyPropertiesLoaded && this.state.cardRefundStatusChecked) {
            const inGracePeriod: boolean = policy.annualPolicyInfo != null ? policy.annualPolicyInfo.inGracePeriod : false;

            // Recreate DataLayer
            new LVDataLayerHelper().mapInteractionToDataLayer(interaction);

            return (
                <>
                    <Overlay show={this.state.displayOverlay}/>
                    {(this.doRedirectToAllianzOnlinePage()) && (<Navigate to={`/allianzOnline?dashboard=true`}/>)}
                    {isAllianzAdvantagesToggleEnabled() && this.doRedirectToAllianzPromotionPage() && (<Navigate to={`/allianzPromotion`}/>)}
                    {this.state.showEditRenewalSuccessPopup && this.renderRenewalEditSuccessModal()}
                    {hasPendingRenewal
                        && !this.state.manualRenewalPopUpIsShown
                        && !this.state.automaticRenewal
                        && (!this.state.performRenewal || inGracePeriod)
                        && !this.hideAutoRenewalBanner
                        && <AnnualHomeManualRenewalModal
                        currentPolicy={policy}
                        payment={this.state.paymentsHistory}
                        instalmentsInfo={this.state.instalmentsInfo}
                        renewalProposal={this.state.renewalProposal!}
                        turnOnNextYearRenewal={this.turnOnManualNextYearRenewal}/>}
                    {this.state.showManualRenewalConfirmation && <AnnualHomeManualRenewalConfirmation
                        currentPolicy={policy}
                        renewalProposal={this.state.renewalProposal!}
                        hideManualRenewalConfirmation={this.hideManualRenewalConfirmation}
                        showAutoRenewalQuestionModal={this.showAutoRenewalQuestionModal}
                    />}
                    {this.referrerJourney === INTERACTION_PROCESS_NB && this.showSuccessPopup &&
                        <SuccessfulPurchaseModal headerText={monthly ? "Deposit payment complete" : "Payment complete"}
                                                 modalContent={this.renderSuccessPopup()}
                                                 onClose={this.closeSuccessPopup}/>
                    }
                    {this.renderMtaOrClaimImpactSuccessPopups(this.referrerJourney, this.showSuccessPopup, interaction, hasPendingRenewal, policy)}
                    {this.state.showRenewalSwitchConfirmation &&
                        <RenewNextYearConfirmationModal product={ProductsEnum.HOME}/>}
                    <FalconHeader/>
                    <div className="page-contents dashboard-page pt-3">
                        {policy?.interaction?.product === ProductsEnum.HOME && <AllianzOnlineBadge policyView={true}/>}
                        <FalconNavigatorHeader
                            back={{
                                link: "/dashboard",
                                hidden: !this.multiPolicyAccount
                            }}
                            title={this.multiPolicyAccount ? `${resourcesHelper.PRODUCT} Home Insurance` : `Hi ${policyHolder.firstName}`}
                        />

                        {this.renderBanners(futureCancelledPolicyBeforeInception, monthly)}
                        {this.renderLinkGrid(futureCancelledPolicyBeforeInception)}
                        {this.multiPolicyAccount && <BackButton isTop={false} link={"/dashboard"}/>}
                        <LvToAllianzUKTransferBanner product={ProductsEnum.HOME} showTitle={true}/>
                    </div>
                    <FalconFooter/>
                </>
            )
        } else {
            return <Overlay show={true}/>
        }
    }

    private renderRenewalEditSuccessModal(): React.ReactNode {
        const {policy} = this.state;
        return <StorageSuccessModal
            title={"We'll apply those changes when your policy renews."}
            explanationWording={
                <p className="mx-4 mb-0 grid-col-2">Changes will apply from your renewal date. For changes starting before your renewal, go to {' '}
                    <a className="font-weight-bold text-decoration-underline"
                    href={`/journey/init/product/AnnualHomeInsurance/process/mta/presetPage/${policy?.interaction._id}`}>Your home, make changes.</a>
                </p>
            }
            explanationWordingStyles={"section-panel banner banner-info banner-info-multiple-paragraphs"}
            passFontAndLineStyles={"font-and-line-styles"}
            onClose={this.renewalEditSuccessModalOnClose}
        />
    }

    private renewalEditSuccessModalOnClose(): void {
        window.sessionStorage.setItem("showRenewalEditSuccessPopup", "false")
        this.setState({
            showEditRenewalSuccessPopup: false
        })
    }

    // @ts-ignore
    private renderBanners(futureCancelledPolicyBeforeInception: boolean, isMonthly: boolean): React.ReactNode {
        const policy: Policy = this.state.policy!;
        if (!policy) {
            return <></>;
        }

        const interaction = policy?.interaction;
        const annualPolicyInfo = policy.annualPolicyInfo;
        const outstandingPaid: string | null = window.sessionStorage.getItem("outstandingPaid");
        const hasActivePolicy: boolean = moment.utc(policy.endDate, moment.ISO_8601).isSameOrAfter(moment(), 'day');
        const hasPendingRenewal: boolean = this.verifyRenewalProposalStatus(POLICY_STATUS_PENDING_RENEWAL);
        const hasRenewalDeclined: boolean = this.verifyRenewalProposalStatus(POLICY_STATUS_UNDERWRITING_FAILURE);
        const address: any = policy?.insuredRealEstates[0].address;
        const showMissedPaymentBanner: boolean = !!annualPolicyInfo && annualPolicyInfo.hasDebt;
        const isDirectDebit: boolean = productHelper.isDirectDebit(interaction);
        const policyCanceled = policy.status === POLICY_STATUS_MTC;

        let showOverdueInstalmentsBanner: boolean = false;
        showOverdueInstalmentsBanner = CommonHelpers
            .showOverdueInstalmentBanner(showMissedPaymentBanner, interaction, isDirectDebit, showOverdueInstalmentsBanner, annualPolicyInfo);

        const hasOverdueAnnualPayment = annualPolicyInfo != null && +annualPolicyInfo.overdueAnnualInvoiceAmount > 0;
        const inGracePeriod: boolean = annualPolicyInfo != null ? annualPolicyInfo.inGracePeriod : false;
        const hasUnpaidChange = policy.annualPolicyInfo.hasUnpaidChange;
        const showNcdImpactedClaimBanner: boolean = this.showNcdImpactedClaimBanner(isMonthly, interaction);
        const lackOfFoundsForMtc: boolean = this.isLackOfFundsMtc(interaction.process, annualPolicyInfo);

        return (
            <>
                {<DashboardCarousel newCarQuotePopUp={this.showNewCarQuotePopUp} newHomeQuotePopUp={this.showNewHomeQuotePopUp}
                                              quotes={this.state.quotes} policy={policy} product={ProductsEnum.HOME} {...this.props}
                                              marketingPreferenceCheckboxStates={this.state.marketingPreferenceCheckboxStates}/>}
                {this.state.newQuotePopUpForProduct !== "" &&
                    <NewQuoteModalPopUp product={this.state.newQuotePopUpForProduct} policy={policy} {...this.props}/>}
                <SportsVoucherBanner/>
                <DashcamBanner/>
                {hasActivePolicy && <SportsPassBanner/>}
                {(!hasActivePolicy || futureCancelledPolicyBeforeInception) && !inGracePeriod && !policy.interaction.uistate.policyHasNcdImpactedClaims && !this.multiPolicyAccount &&
                    <NoActivePolicyBanner/>
                }
                {showNcdImpactedClaimBanner && <NCDImpactedClaimBanner product={ProductsEnum.HOME}/>}
                {lackOfFoundsForMtc && <LackOfFoundsDelinquencyBanner
                    interaction={interaction}
                    policyInfo={annualPolicyInfo}
                    amount={annualPolicyInfo.overdueMonthlyInvoiceAmount}
                    reuseCard={this.state.reuseCard}
                />}
                {interaction && !lackOfFoundsForMtc && (!showOverdueInstalmentsBanner || hasOverdueAnnualPayment) && !futureCancelledPolicyBeforeInception && this.showPolicyCancelledBanner() && (
                    <AnnualProductPaymentMessageBanner
                        policyInfo={annualPolicyInfo}
                        showInfoModal={false}
                        interaction={interaction}
                        showMissedPaymentBanner={showMissedPaymentBanner}
                        instalmentsInfo={this.getInstalmentsInfoForBanner(showNcdImpactedClaimBanner)}
                        hasRenewalDeclined={false}
                        amount={isMonthly ? annualPolicyInfo.overdueMonthlyInvoiceAmount : annualPolicyInfo.overdueAnnualInvoiceAmount}
                        ncdImpactedClaim={policy.interaction.uistate.policyHasNcdImpactedClaims}
                    />)}
                {annualPolicyInfo && !lackOfFoundsForMtc && showOverdueInstalmentsBanner && (
                    <OverdueInstalmentBanner amount={annualPolicyInfo.overdueMonthlyInvoiceAmount}
                                             unpaidInstallmentIdToAmount={annualPolicyInfo.unpaidInstallmentIdToAmount}
                                             policyNumber={interaction.agreementNumber}
                                             product={ProductsEnum.HOME}
                                             reuseCard={this.state.reuseCard}/>
                )}
                {!this.state.performRenewal && !hasPendingRenewal && !inGracePeriod && !policyCanceled &&
                    <NextYearAutoRenewalBanner setPerformRenewal={this.setPerformRenewal}
                                                turnOnNextYearRenewal={this.turnOnNextYearRenewal}/>
                }
                {!!policy?.annualPolicyInfo.unpaidChargebackInvoiceAmount && !outstandingPaid &&
                    <OutstandingPaymentBanner
                        amount={policy.annualPolicyInfo.unpaidChargebackInvoiceAmount}
                        policyNumber={policy.policyNumber}
                        product={policy.interaction.product}
                    />
                }
                {hasPendingRenewal && !inGracePeriod && (this.state.automaticRenewal || this.state.performRenewal) &&
                    <PolicyWillBeRenewedBanner
                        renewalProposal={this.state.renewalProposal}
                        product={ProductsEnum.HOME}
                        productContent={<>{address.addressLine1}, ... {address.postalCode}</>}
                        monthlyInstalmentsAllowed={this.state.renewalProposal?.radarPolicyData?.instalmentAllowedStatus === "A"}
                    />
                }
                {hasPendingRenewal && !inGracePeriod && !this.state.automaticRenewal && !this.state.performRenewal && policy &&
                    <AutoRenewalInviteBanner
                        renewalProposal={this.state.renewalProposal!}
                        setAutomaticRenewal={this.setAutomaticRenewal}
                        setPerformRenewal={this.setPerformRenewal}
                        showHideWillBeRenewedConfirmation={this.setShowManualRenewalConfirmation}
                        monthlyInstalmentsAllowed={this.state.renewalProposal?.radarPolicyData?.instalmentAllowedStatus === "A"}
                        renewalEditUrl={ANNUAL_HOME_RENEWAL_PROPOSAL_EDIT_VIEW_JOURNEY_URL}
                        productWording={
                            <>
                                Your {resourcesHelper.PRODUCT} Home Insurance policy for{' '}
                                <strong>{address.addressLine1}, ... {address.postalCode} ends on{' '}
                                {formatDateTime(policy.endDate)}.</strong> Until then you're still covered.
                            </>
                        }
                    />
                }
                {hasPendingRenewal && !this.state.automaticRenewal && inGracePeriod &&
                    <GracePeriodBanner
                        renewalProposal={this.state.renewalProposal!}
                        policy={policy}
                        address={address}
                        interaction={interaction}
                    />}
                {hasRenewalDeclined &&
                    <RenewalDeclinedBanner product="home"
                        endDate={policy.endDate}
                        productWording={<>{address.addressLine1}, ... {address.postalCode}</>}
                    />
                }
                {hasUnpaidChange &&
                    <UnpaidChangeBanner unpaidChangeDueDate={annualPolicyInfo.unpaidChangeDueDate}
                                        interaction={interaction}/>
                }
                {(this.state.showAutoRenewalQuestionModal) &&
                    <AutoRenewalQuestionModal
                        onSave={this.setAutomaticRenewalAndCloseAutoRenewalQuestionModal}
                        product={ProductsEnum.HOME}
                    />}
                {this.state.showAutoRenewalQuestionSuccessModal && this.state.performRenewal !== undefined &&
                    <AutomaticRenewalSuccessModal
                        automaticRenewal={this.state.automaticRenewal}
                        nextYearRenewal={this.state.performRenewal}
                        product={ProductsEnum.HOME}
                        closeSuccessModal={this.closeAutoRenewalQuestionSuccessModal}
                    />}
                {(this.state.hasFailedCardRefundAndApplicableForDD) &&
                    <RefundPaymentDetailsUpdateBanner
                        policyNumber={policy.policyNumber}
                        showPolicyNumber={false}
                    />}
            </>
        );
    }

    private renderMtaOrClaimImpactSuccessPopups(referrerJourney: string | null, showSuccessPopup: string | null, interaction: any, hasPendingRenewal: boolean, policy: any): React.ReactNode {
        const instalmentPlan: any = interaction.paymentDetails.instalmentPlan;
        const payFullPrice: boolean = interaction.uistate?.payFullPrice;
        const payUpfrontInterest: boolean = !payFullPrice && instalmentPlan.upfrontInterestCorrectionPayment > 0;
        const upfrontInterestAmount: string = instalmentPlan.upfrontInterestCorrectionPayment;
        const cardEnding: string = this.getCardEnding(interaction.policyHolder);
        const renewalPrice: any = hasPendingRenewal && interaction.uistate.totalRenewalAmount ? interaction.uistate.totalRenewalAmount : undefined;
        // instalmentsInfo.remainingAmount is 0 if all instalments are paid or the last isn’t paid and fewer than 10 working days remain
        // check method FalconPartyServiceImpl.adjustRemainingAmountForInvoicesWithDueDateLessThan10WorkingDays()
        const instalmentsPaidOff: boolean = interaction.factors.premiumType === AnnualPolicyPremiumTypeEnum.MONTHLY && this.state.instalmentsInfo?.remainingAmount === 0;
        const totalInstalments: number = this.state.instalmentsInfo?.instalments?.length ?? 0;
        const isPaymentsDone: boolean = totalInstalments === 0;

        if (referrerJourney === INTERACTION_PROCESS_CHANGE_ADDRESS && showSuccessPopup) {
            return <ChangeAddressStorageSuccessModal
                factors={interaction.factors}
                payFullPrice={payFullPrice}
                cardEnding={cardEnding}
                renewalPrice={renewalPrice}
                instalmentsPaidOff={instalmentsPaidOff}
                isPaymentsDone={isPaymentsDone}
            />
        } else if (referrerJourney === INTERACTION_PROCESS_MTA && showSuccessPopup) {
            return <MtaStorageSuccessModal
                factors={interaction.factors}
                payFullPrice={payFullPrice}
                cardEnding={cardEnding}
                payUpfrontInterest={payUpfrontInterest}
                upfrontInterestAmount={upfrontInterestAmount}
                renewalPrice={renewalPrice}
                instalmentsPaidOff={instalmentsPaidOff}
                isPaymentsDone={isPaymentsDone}
            />
        } else if (referrerJourney === INTERACTION_PROCESS_RENEWAL && showSuccessPopup) {
            return <GracePeriodRenewalStorageSuccessModal
                policy={policy}
                cardEnding={cardEnding}
            />
        } else if (referrerJourney === INTERACTION_PROCESS_CLAIM_IMPACT && showSuccessPopup) {
            const interaction = policy.interaction;

            const {factors, uistate, paymentDetails, policyHolder, agreeToReuseCardDetails} = interaction;

            const mtaSuccessMessageText = window.sessionStorage.getItem("mtaSuccessMessageText");

            const wording = ClaimImpactMtaSuccessModalWordingGenerator.generateModalWording(
                factors, paymentDetails.instalmentPlan!.monthlyPayment, uistate.payFullPrice, mtaSuccessMessageText,
                policyHolder.cardDetails?.at(-1)?.number, agreeToReuseCardDetails);

            return <SuccessfulPurchaseModal headerText={this.getHeaderText(wording)}
                                            modalContent={(<>{wording.modalBody}</>)}
                                            onClose={this.closeSuccessPopup}/>
        } else {
            return <></>
        }
    }

    private getCardEnding(policyHolder: any): string { // returns at least "****" in case of empty cardDetails
        return policyHolder.cardDetails?.at(-1)?.number?.slice(-4)
            ? policyHolder.cardDetails.at(-1)!.number.slice(-4)
            : '****';
    }

    private getHeaderText(wording: MtaSuccessModalWording) {
        return wording.modalTitle && typeof wording.modalTitle === 'string' ? wording.modalTitle : "";
    }

    private verifyRenewalProposalStatus(checkStatus: string) {
        return this.state.renewalProposal != null && this.state.renewalProposal.status === checkStatus;
    }

    private loadPaymentsHistoryWhenInRenewalWindow(filteredPolicy: Policy, policyNumber: string): void {

        // load payments only when in renewal window, required for manual renewal modal
        const dateDiff = moment.utc(filteredPolicy.endDate, moment.ISO_8601).diff(moment(), 'days');
        const daysBeforeRenewalIssued : number = 32;
        if (dateDiff <= daysBeforeRenewalIssued) {
            this.customerPortalService.getPaymentHistoryCurrentPeriod(policyNumber).subscribe((payment: PaymentsResponse) => {
                const filteredPayments: PaymentsResponse = payment;
                filteredPayments.paymentDetailsList = filteredPayments.paymentDetailsList.filter((paymentDetails) => {
                    return this.checkPaymentInCurrentPolicy(filteredPolicy, paymentDetails);
                });
                this.setState({
                    paymentsHistory: filteredPayments
                });
            });
        }
    }

    private checkPaymentInCurrentPolicy(filteredPolicy: Policy, paymentDetails: PaymentDetails): boolean {
        return !!filteredPolicy.policyHistoryList?.find((policyHistory: PolicyHistory) => paymentDetails.policyVersion.some(x => x.id === policyHistory.id.toString()));
    }

    private prepareClaimsTileLink(): { claimsLink: string; useHomeDirectClaimsLink: boolean } {
        const defaultClaimsLink = this.state.policy?.interaction?.annualHomeFixedAddons?.homeEmergency
            ? `/dashboard/annualHome/${this.props.params.policyNumber}/claims/new`
            : `/dashboard/annualHome/${this.props.params.policyNumber}/claims/details`;

        const homeDirectClaimsLink = buildDigitalClaimsUrl(
            process.env.REACT_APP_HOME_OTHER_CLAIM_URL,
            this.props.params.policyNumber
        );

        const useHomeDirectClaimsLink = resourcesHelper.THEME !== "Britannia" && this.state.allianzDirectClaimsEnabled && homeDirectClaimsLink != null;

        if (!useHomeDirectClaimsLink && !this.state.policy?.interaction?.annualHomeFixedAddons?.homeEmergency) {
            setSessionStorage("claim", CLAIM_TYPE_OTHER);
        }

        return {
            claimsLink: useHomeDirectClaimsLink && homeDirectClaimsLink
                ? homeDirectClaimsLink
                : defaultClaimsLink,
            useHomeDirectClaimsLink
        };
    }

    public renderLinkGrid(futureCancelledPolicyBeforeInception: boolean): React.ReactNode {
        const {policy} = this.state;
        const policyCanceled = policy && policy.status === POLICY_STATUS_MTC;
        const policyStarted = policy && moment().isAfter(moment(policy.startDate));
        const policyActive = policy != null && moment.utc(policy.endDate, moment.ISO_8601).isSameOrAfter(moment(), 'day');
        const hasPendingRenewal: boolean = this.state.renewalProposal != null && this.state.renewalProposal.status === POLICY_STATUS_PENDING_RENEWAL;
        const renewalStatus: string | undefined = hasPendingRenewal ? "Existing" : undefined;
        const {claimsLink, useHomeDirectClaimsLink} = this.prepareClaimsTileLink();
        const isBritannia = resourcesHelper.THEME === "Britannia";
        const quoteBadgeText = !isBritannia ? this.renderQuoteBadge(getSavedValidQuotesCount(this.state.quotes), false) : undefined;
        const quoteMobileBadgeText = !isBritannia ? this.renderQuoteBadge(getSavedValidQuotesCount(this.state.quotes), true) : undefined;
        const futureCancelledPolicy : boolean = policy != null && moment.utc(policy.endDate, moment.ISO_8601).isAfter(moment());

        const inGracePeriod: boolean = policy?.annualPolicyInfo ? policy.annualPolicyInfo.inGracePeriod : false;

        return (
            <div className="link-grid">
                <div className="d-flex flex-wrap">
                    {hasPendingRenewal &&
                        <div className="flexItem pending-renewal">
                            <ImgTileLink src={inGracePeriod ? `/${resourcesHelper.THEME}/img/pending_renewal_gray.svg` : `/${resourcesHelper.THEME}/img/pending_renewal.png`}
                                         alt="Policy renewal icon"
                                         to={ANNUAL_HOME_RENEWAL_PROPOSAL_EDIT_VIEW_JOURNEY_URL + this.state.renewalProposal!._id}
                                         status="New"
                                         hasInfoButton={true}
                                         linkDisabled={inGracePeriod}
                                         backButtonName={inGracePeriod ? "Cancel" : "Back"}
                                         infoModalButtonHidden={inGracePeriod}
                                         infoModalTitle="Your renewal, make changes"
                                         infoModalAdditionalDescription={inGracePeriod ? <div className="banner-text banner-warn-renewal p-4 mb-3">
                                             <div className="banner-text">
                                                 <p className="font-weight-bold">You are no longer covered</p>
                                                 <p>
                                                     You must renew your {resourcesHelper.PRODUCT} Home Insurance policy
                                                     before making any changes to your cover
                                                 </p>
                                                 <Link className="color-cyan-blue"
                                                       to={ANNUAL_HOME_RENEWAL_PROPOSAL_EDIT_VIEW_JOURNEY_URL + this.state.renewalProposal!._id}>
                                                 <p className="font-weight-bold hyperlink mt-2 mb-2">
                                                         <img alt="Arrow icon" src={`/${resourcesHelper.THEME}/img/arrow-right.svg`}/>Renew your policy now
                                                     </p>
                                                 </Link>

                                             </div>
                                         </div> : ""}
                                         infoModalBulletPoints={[
                                             "Make changes to your next year home policy (e.g. add a bicycle)",
                                             "Change from annual payment to monthly instalments or vice versa (if instalments are available)",
                                             "Add or remove optional extras (e.g. add Home Legal Expenses)"]}
                                         {...this.props}
                            >
                                Your renewal, make changes
                            </ImgTileLink>
                        </div>
                    }
                    {!futureCancelledPolicyBeforeInception && policyActive &&
                        <div className="flexItem policy-summary">
                            <ImgTileLink
                                src={`/${resourcesHelper.THEME}/img/policy-summary.png`}
                                alt="Policy summary section"
                                to={`/dashboard/annualHome/policySummary/${this.props.params.policyNumber}`}
                                hasInfoButton={true}
                                infoModalTitle={`Your ${resourcesHelper.PRODUCT} Home Insurance policy`}
                                infoModalButton="Policy summary"
                                infoModalBulletPoints={[`View a short breakdown of your ${resourcesHelper.PRODUCT} Home Insurance policy`]}
                                status={renewalStatus}
                                {...this.props}
                            >
                                Policy summary
                            </ImgTileLink>
                        </div>
                    }
                    { policyCanceled && !futureCancelledPolicy &&
                        <div className="flexItem old-policies">
                            <ImgTileLink src={`/${resourcesHelper.THEME}/img/old-policies.png`}
                                         alt="Policy summary section"
                                         to={`/dashboard/annualHomeOldPolicies/${this.props.params.policyNumber}`}
                                         hasInfoButton={true}
                                         infoModalTitle="Policy summary"
                                         infoModalBulletPoints={[`View a short breakdown of your ${resourcesHelper.PRODUCT} Home Insurance policy`]}
                                         {...this.props}>
                                Policy summary
                            </ImgTileLink>
                        </div>
                    }
                    {!inGracePeriod && !policyCanceled && (<div className="flexItem home">
                        <ImgTileLink
                            src={`/${resourcesHelper.THEME}/img/home-icon.png`}
                            alt="Your home, make changes section"
                            to={`/journey/init/product/AnnualHomeInsurance/process/mta/presetPage/${policy?.interaction._id}`}
                            hasInfoButton={true}
                            infoModalTitle="Your home, make changes"
                            infoModalBulletPoints={[
                                "Make changes to your home policy (e.g. property use)",
                                "Add or remove optional extras (e.g. Home Legal expenses)",
                                "Change your cover level"
                            ]}
                            status={renewalStatus}
                            {...this.props}
                        >
                            Your home, make changes
                        </ImgTileLink>
                    </div>)}
                    <div className="flexItem payment">
                        <ImgTileLink
                            src={`/${resourcesHelper.THEME}/img/payment-card-icon.png`}
                            alt="Payment section"
                            to={`/dashboard/annualPaymentHistory/${this.props.params.policyNumber}`}
                            hasInfoButton={true}
                            infoModalTitle="Payment"
                            infoModalBulletPoints={["Change your payment day",
                                "Edit your Direct Debit payment details",
                                "Change your payment card",
                                "Pay off your balance",
                                "View payment history",
                                "Opt in to auto-renew your policy"]}
                            {...this.props}
                        >
                            Payment
                        </ImgTileLink>
                    </div>
                    <div className="flexItem documents">
                        <ImgTileLink
                            src={`/${resourcesHelper.THEME}/img/documents-icon.png`}
                            alt="Documents and Communications"
                            to={`/dashboard/annualHomeDocuments/${this.props.params.policyNumber}`}
                            hasInfoButton={true}
                            infoModalTitle="Documents"
                            infoModalBulletPoints={["View your policy documents",
                                "View your old policy documents",
                                "Request documents to be sent by post"]}
                            {...this.props}
                        >
                            Documents and Communications
                        </ImgTileLink>
                    </div>
                    {policyStarted && <div className="flexItem make-a-claim">
                        <ImgTileLink
                            src={`/${resourcesHelper.THEME}/img/make-a-claim.png`}
                            alt="Make a claim section"
                            to={claimsLink}
                            openInNewWindow={useHomeDirectClaimsLink}
                            hasInfoButton={true}
                            infoModalTitle="Make a claim"
                            infoModalBulletPoints={["Make a contents claim", "Make a buildings claim"]}
                            {...this.props}
                        >
                            Make a claim
                        </ImgTileLink>
                    </div>}
                    <div className="flexItem quotes">
                        <ImgTileLink id="getQuoteTile"
                                     src={`/${resourcesHelper.THEME}/img/savings_icon.png`}
                                     alt="Products icon"
                                     to={`/dashboard/getNewQuote`}
                                     routeState={{
                                         policy,
                                     }}
                                     hasInfoButton={true}
                                     infoModalTitle="Our Allianz products"
                                     infoModalBulletPoints={[
                                         `View your ${resourcesHelper.PRODUCT} Car or Home insurance quotes`,
                                         `Get a new ${resourcesHelper.PRODUCT} Car or Home insurance quote`,
                                         "Get a new LV= Travel or LV= Pet insurance quote"
                                     ]}
                                     infoModalButton="More about Allianz products"
                                     badgeText={quoteBadgeText}
                                     mobileBadgeText={quoteMobileBadgeText}
                                     {...this.props}>
                            {isBritannia ? "Our products" : "Our products & quotes"}
                        </ImgTileLink>
                    </div>
                    {!this.multiPolicyAccount &&
                        <div className="flexItem account-details">
                            <ImgTileLink
                                src={`/${resourcesHelper.THEME}/img/account-details.png`}
                                alt="Account details section"
                                to={`/dashboard/annualHome/account/${this.props.params.policyNumber}`}
                                hasInfoButton={true}
                                infoModalTitle="Account details"
                                infoModalBulletPoints={["View and amend account holder details (e.g. email, mobile number, address, password)",
                                    "Opt in to auto-renew your policy"]}
                                {...this.props}
                            >
                                Account details
                            </ImgTileLink>
                        </div>
                    }
                    <div className="flexItem help">
                        <ImgTileLink
                            src={`/${resourcesHelper.THEME}/img/help.png`}
                            alt="Help icon"
                            to={FAQ_HOME_URL}
                            hasInfoButton={true}
                            infoModalTitle="Help"
                            infoModalBulletPoints={["View 'How to' videos and guides",
                                "Read FAQs about your cover, account, payment, renewal, claims, etc."]}
                            openInNewWindow={true}
                            {...this.props}
                        >
                            Help
                        </ImgTileLink>
                    </div>
                    {!inGracePeriod && !policyCanceled && (<div className="flexItem cancel-policy">
                        {this.getCancellationTile()}
                    </div>)}

                    {policyActive && !this.multiPolicyAccount && !isAllianzAdvantagesToggleEnabled() && <div className="flexItem savings">
                        <ImgTileLink src={`/${resourcesHelper.THEME}/img/gift_icon.svg`}
                                     alt="Offers icon"
                                     to={`https://www.allianz.co.uk/insurance/car-insurance/customer-offers`}
                                     openInNewWindow={true}
                                     hasInfoButton={true}
                                     infoModalTitle="My offers"
                                     infoModalBulletPointTitle="Our way of saying thanks"
                                     infoModalBulletPoints={["Save with exclusive offers from Allianz"]}
                                     {...this.props}>
                            My offers
                        </ImgTileLink>
                    </div>}

                    {policyActive && isAllianzAdvantagesToggleEnabled() && <div className="flexItem advantages">
                        <ImgTileLink id="getAdvantagesTile"
                                     src={`/${resourcesHelper.THEME}/img/allianz-star.svg`}
                                     alt={`${resourcesHelper.THEME} Advantages icon`}
                                     to={`/dashboard/advantages`}
                                     routeState={{
                                         policy,
                                     }}
                                     infoModalBulletPointTitle={`Our way of saying thanks`}
                                     hasInfoButton={true}
                                     infoModalTitle="Allianz Advantages"
                                     infoModalBulletPoints={["Save with exclusive offers from Allianz"]}
                                     infoModalButton="Allianz Advantages"
                                     {...this.props}>
                            {resourcesHelper.THEME} Advantages
                        </ImgTileLink>
                    </div>}
                    {(this.state.hasExpiredPolicies || this.state.hasOldPolicies) && policyActive && (
                        <div className="flexItem old-policies">
                            <ImgTileLink src={`/${resourcesHelper.THEME}/img/old-policies.png`}
                                         alt="Old policies"
                                         to={this.state.hasOldMotorPolicies ? "/dashboard/annualOldPolicies" : "/dashboard/annualHomeOldPolicies"}
                                         hasInfoButton={true}
                                         infoModalTitle="Old policies"
                                         infoModalBulletPoints={["View your previous policies"]}
                                         {...this.props}>
                                Old policies
                            </ImgTileLink>
                        </div>
                    )}
                    { !this.multiPolicyAccount &&
                        <div className="flexItem marketing-preferences">
                            <ImgTileLink
                                src={`/${resourcesHelper.THEME}/img/exclamation-mark-dark.svg`}
                                alt="Marketing preferences"
                                to={"/dashboard/marketing-preferences"}
                                hasInfoButton={true}
                                infoModalTitle="Marketing preferences"
                                infoModalBulletPoints={["Change your marketing preferences (hear about our latest products, services and discounts)"]}
                                {...this.props}
                            >
                                Marketing preferences
                            </ImgTileLink>
                        </div>
                    }
                </div>
            </div>
        )
    }

    private renderSuccessPopup(): React.ReactNode {
        const policy: Policy = this.state.policy!;
        if (!policy) {
            return;
        }

        const monthly: boolean = policy.interaction?.factors?.premiumType === AnnualPolicyPremiumTypeEnum.MONTHLY;

        return (
            <div>
                <h3 className="font-weight-bold mb-4">
                    Thanks {policy.policyHolder.firstName}
                </h3>
                <p className="mb-4">
                    When you’re ready, check your documents
                    in <a className={"link"}
                          href={`/dashboard/annualHomeDocuments/${this.props.params.policyNumber}`}>your
                    {" "}{resourcesHelper.THEME} account</a>. This is also where you’ll manage your policy and make any changes.
                </p>
                {monthly &&
                    <p className="mb-4">
                        Your Direct Debit instruction will be confirmed to you by email within 3 working days or no
                        later
                        than 10 working days before the first collection.
                    </p>
                }
                <p className="mb-4">
                    Remember, we’re just a phone call away if you need to claim, for everything else it’s over to
                    you! If you get stuck, email us and we’ll reply within 24 hours.
                </p>

                {this.state.showMarketingPreferencesInSuccessPopup && (
                    <div className="inner-container marketing-preference marketing-preference--compact">
                        <div className="panel-detail-output-entity text-left">
                            <div className="widget marketing-widget">
                                <div>
                                    <h3 className="font-weight-bold mb-4">
                                        Don't miss out, we'd love to keep you up to date
                                    </h3>
                                    <p className="margin-bottom-20">
                                            <span className="font-weight-semi-bold">
                                                How would you like to hear about our latest offers, products and discounts?
                                            </span>{" "}
                                        You can opt in or out at any time from your account.
                                    </p>
                                </div>
                                <div className="checkBox">
                                    {this.renderMarketingPreferenceCheckboxes(this.marketingPreferenceCheckboxes)}
                                </div>
                                <div>
                                    <p>
                                        Just so you know, if you don’t opt in to our emails, we won’t be able to
                                        send
                                        you our newsletter with the latest offers and rewards for being an Allianz
                                        customer such as priority rugby tickets and an exclusive dashcam discount.
                                        Don’t miss out!
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                <p>To use our live chat <img src={`/${resourcesHelper.THEME}/img/chat.svg`}
                                                         alt="Chat"/> please visit our <a
                    className={"help-popup-hyperlink-style"}
                    href={CONTACT_US_URL}
                    target="_blank">contact page</a>.
                </p>
                <p className="mt-3 font-weight-bold">Welcome to the {resourcesHelper.THEME} family!</p>
                <div className={"d-flex"}>
                    <img src={`/Allianz/img/allianz-olympic-logo.svg`}
                         alt={`${resourcesHelper.THEME} olympics logo icon`}/>
                </div>
            </div>
        );
    }

    private readonly renderQuoteBadge = (quoteCount: number, isMobile: boolean): React.ReactNode => {
        const quoteText: string = quoteCount === 1 ? "quote" : "quotes";
        if (isMobile) {
            return (<p><span className="muli-bold-16">{quoteCount}</span> {quoteText}</p>);
        }
        return (
            <p>You have <span className="muli-bold-16">{quoteCount}</span> {quoteText}</p>
        );
    };

    private readonly renderMarketingPreferenceCheckboxes = (preferences: any[]) => {
        return preferences.map(value => (
            <label key={value.type} className={`${value.className}-preference`}>
                <input
                    type="checkbox"
                    name={value.type}
                    id={value.type}
                    aria-label={value.label}
                    checked={this.state.marketingPreferenceCheckboxStates[value.type]}
                    onChange={() => this.updateMarketingPreferenceCheckboxState(value.type)}
                />
                <div className="checkbox">
                    <span className={`icon ${value.icon ?? value.className}-icon`}/>
                    <span className="text font-weight-semi-bold">{value.label}</span>
                </div>
            </label>
        ));
    };

    private readonly updateMarketingPreferenceCheckboxState = (key: string) => {
        this.setState(prevState => ({
            marketingPreferenceCheckboxStates: {
                ...prevState.marketingPreferenceCheckboxStates,
                [key]: !prevState.marketingPreferenceCheckboxStates[key]
            },
            marketingPreferencesEdited: true
        }));
    };

    private getCancellationTile(): React.ReactNode {
        if (this.state.renewalProposal && this.state.performRenewal) {
            return (
                <ImgTileLink
                    src={`/${resourcesHelper.THEME}/img/cancel-policy-icon.png`}
                    alt="Cancel policy section"
                    to={`/dashboard/home/cancel/${this.props.params.policyNumber}`}
                    routeState={{
                        mtcJourneyUrl: `/journey/init/product/AnnualHomeInsurance/process/mtc/presetPage/${this.state.policy?.interaction?._id}`,
                        renewalCancellationUrl: `/journey/show/product/AnnualHomeInsurance/process/renewal/cancellationPresetPage/${this.state.renewalProposal._id}`,
                        pageTitle: "Cancel home policy",
                        questionTitle: "When would you like your home policy to end?"
                    }}
                    hasInfoButton={true}
                    infoModalTitle="Cancel policy"
                    infoModalBulletPoints={["Cancel your policy"]}
                    {...this.props}
                >
                    Cancel policy
                </ImgTileLink>
            )
        } else {
            return (
                <ImgTileLink
                    src={`/${resourcesHelper.THEME}/img/cancel-policy-icon.png`}
                    alt="Cancel policy section"
                    to={`/journey/init/product/AnnualHomeInsurance/process/mtc/presetPage/${this.state.policy?.interaction?._id}`}
                    hasInfoButton={true}
                    infoModalTitle="Cancel policy"
                    infoModalBulletPoints={["Cancel your policy"]}
                    {...this.props}
                >
                Cancel policy
                </ImgTileLink>
            )
        }
    }


    private turnOnManualNextYearRenewal(): void {
        this.setPerformRenewal(true);
        window.sessionStorage.setItem("manualRenewalPopUpIsShown", "true")
        this.setShowManualRenewalConfirmation(true)
    }

    private setShowManualRenewalConfirmation(value: boolean) {
        this.setState({
            showManualRenewalConfirmation: value
        })
    }

    private hideManualRenewalConfirmation(): void {
        this.setState({
            showManualRenewalConfirmation: false
        })
    }

    private showPolicyCancelledBanner(): boolean {
        const endDate: any = moment.utc(this.state.policy?.interaction.headerInfo.endDate, moment.ISO_8601);
        return (!this.state.bannerShownLocally || this.state.bannerShownInSession || !endDate.isBefore(moment(), 'day'));
    }

    protected readonly continueAfterSuccessPopupClose = (): void => {
        this.setRedirectToAllianzPromotionPage();
    };

    private readonly setAutomaticRenewalAndCloseAutoRenewalQuestionModal = (automaticRenewal: boolean): void => {
        this.setPerformRenewal(true);
        this.setAutomaticRenewal(automaticRenewal);
        this.setState({
            showAutoRenewalQuestionModal: false,
            showAutoRenewalQuestionSuccessModal: true,
            performRenewal: true,
            automaticRenewal
        })
    }

    private loadAllianzDirectClaimsSwitch(): void {
        this.falconConvenienceApiService
            .getSettings()
            .subscribe((settings: ISettings): void => {
                const allianzDirectClaimsEnabled: any = settings?.allianzDirectClaimsEnabled;
                this.setState({
                    allianzDirectClaimsEnabled: allianzDirectClaimsEnabled === true || allianzDirectClaimsEnabled === "true"
                });
            });
    }

}

export const AnnualHomeDashboardPage = withRouter<{}, IDashboardParams>(AnnualHomeDashboardPagePlain)
